import React, { Dispatch, SetStateAction } from "react"
import {
  CheckIcon,
  FilterContainer,
  InputWrapper,
  OperationButton,
  OperationButtonWrapper, XmarkIcon
} from "./Shared.styled"
import { Common } from "lib/types"
import MultiSelect from "../Ui/Form/MultiSelect"
import { CustomOperation } from "lib/types/generated/graphql-types"
import { getFormattedOperation } from "./helpers"

type Props = {
  storeGroupOptions: Common.Option[]
  countryCodeOptions: Common.Option[]
  setFilter: Dispatch<SetStateAction<Common.OrderOperationsFilter>>
  filter: Common.OrderOperationsFilter
}

const OperationsFilter = ({ storeGroupOptions, countryCodeOptions, setFilter, filter }: Props) => {
  const setStoreGroups = (storeGroups: string[]) => {
    setFilter({ ...filter, storeGroups })
  }

  const setCountryCodes = (countryCodes: string[]) => {
    setFilter({ ...filter, countryCodes })
  }

  const operationExistsInFilter = (operation: CustomOperation) =>
    filter.operations.find((o) => o === operation)

  const updateOperations = (operation: CustomOperation) => {
    if(!operationExistsInFilter(operation)) {
      const array = [...filter.operations]
      array.push(operation)
      setFilter({ ...filter, operations: array})
      return
    }
    const array = [...filter.operations]
    setFilter({ ...filter, operations: array.filter((o) => o !== operation) })
  }

  return (
    <FilterContainer>
      <InputWrapper>
        <MultiSelect setValue={setStoreGroups} options={storeGroupOptions} placeholder={"Store group"} />
        <MultiSelect setValue={setCountryCodes} options={countryCodeOptions} placeholder={"Country"} />
      </InputWrapper>
      <OperationButtonWrapper>
        {[
          CustomOperation.Delivery,
          CustomOperation.Cancellation,
          CustomOperation.Refund,
          CustomOperation.Release,
          CustomOperation.Compensation,
          CustomOperation.ModifyOrderLines
        ].map((operation) => (
          <OperationButton onClick={() => updateOperations(operation)} key={operation}>
            {operationExistsInFilter(operation) ? <CheckIcon /> : <XmarkIcon/>}
            {getFormattedOperation(operation)}
          </OperationButton>
        ))}
      </OperationButtonWrapper>
    </FilterContainer>
  )
}

export default OperationsFilter
